import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { appUrls } from '../../utils/urls/appUrls';
import { clearAll as clearAllTransferee } from '../../config/redux/slice/transfereeUserSlice';
import { clearAll } from '../../config/redux/slice/bankUserSlice';
import { clearOnReload, onGetCurrencies, setActiveSidebar } from '../../config/redux/slice/appSlice';
import { handleOnPageLoad, handleOverlayClick } from '../../helpers/sideBarToggle';
import { currencies } from '../../constants/currencies';
import { ROLES } from '../../constants';

import HeaderLayout from './HeaderLayout';
import SideBarLayout from './SideBarLayout';
import FooterLayout from './FooterLayout';
import GeneralDocumentModal from '../pages/CertificateManagement/GeneralDocumentModal';

import '../../assets/css/layoutStyles.css'
import '../../assets/css/certifcateStyles.css'

export default function AppWrapper({children, pageTitle}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { reference_number } = useParams();
    const { token, userData: {isProfileComplete, isAdmin, user_role} } = useSelector((state) => state.authData)
    const { certificateManagement:{showDocumentModal, document_file_path} } = useSelector((state) => state.app)  

    const handleNavigation = useCallback(() => {
        if (token) return;

        if (isAdmin) return;
  
        if (reference_number) return;
  
        if (!isProfileComplete) return navigate(appUrls.profileCreation);
  
        navigate(appUrls.login);
    }, [navigate, token, isAdmin, reference_number, isProfileComplete]);

    const getCurrencies = useCallback(() =>{
      dispatch(clearAll({}))
      dispatch(clearAllTransferee({}))
      dispatch(onGetCurrencies(currencies))
    }, [dispatch]);

    useEffect(() => {
      dispatch(clearOnReload());
      handleNavigation();
      handleOnPageLoad();
      getCurrencies();
    }, [handleNavigation, getCurrencies, dispatch]);

    useEffect(() => {
        let mainPath = '';
        let path = window.location.pathname;
        let fullPathArray = path.split("/");

        if (fullPathArray.length <= 2) mainPath = `/${fullPathArray[1]}`
        else mainPath = user_role === ROLES.TRANSFEREE.TEXT ? `/${fullPathArray[1]}` : `/${fullPathArray[1]}/${fullPathArray[2]}`;

        dispatch(setActiveSidebar({ mainPath }));
    }, [dispatch, user_role]);

    return (
        <div className="navbar-fixed sidebar-fixed" id="body">
          <div onClick={handleOverlayClick} className='mobile-sticky-body-overlay'></div>
                    
          <div className="wrapper">
              <SideBarLayout/>
              
              <div className="page-wrapper">
                  <HeaderLayout/>
                    
                  <div className='px-2 px-sm-3 px-md-5 pb-8 pt-5 mb-8 mb-md-5'>
                    <h4 style={{marginBottom: '2rem'}}>{pageTitle}</h4>
                    {children}
                  </div>
                  
                  <FooterLayout/>
              </div>
          </div>
          
          {showDocumentModal && <GeneralDocumentModal filePath={document_file_path}/>}
        </div>
    );
}
